<script setup>
import { ClipboardIcon } from '@hugeicons/core-free-icons';

import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';
import SettingsBackButton from './SettingsBackButton.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  backAriaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['back']);
</script>

<template>
  <header
    class="shrink-0 border-b border-n-weak bg-n-surface-1 px-4 pt-2 pb-1 md:bg-n-solid-1 md:px-4 md:pt-3 md:pb-1"
  >
    <div class="flex items-start justify-between gap-4">
      <div class="flex min-w-0 flex-1 flex-col gap-0">
        <div class="flex min-h-7 items-center gap-1.5">
          <SettingsBackButton
            icon-only
            class="shrink-0"
            :aria-label="backAriaLabel"
            @click="emit('back', $event)"
          />
          <HugeIcon
            :icon="ClipboardIcon"
            :size="22"
            class="size-[22px] shrink-0 text-n-slate-12"
          />
          <h1
            class="mb-0 min-w-0 flex-1 truncate text-base font-bold leading-none text-n-slate-12 md:text-lg"
          >
            {{ title }}
          </h1>
        </div>

        <div v-if="subtitle" class="flex items-start gap-1.5">
          <span class="size-7 shrink-0" aria-hidden="true" />
          <p
            class="mb-0 min-w-0 flex-1 text-xs font-normal leading-snug text-n-slate-11"
          >
            {{ subtitle }}
          </p>
        </div>
      </div>

      <div v-if="$slots.actions" class="flex shrink-0 items-center self-center">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>
